import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '@/pages/Dashboard';
import Bins from '@/pages/Bins';
import Fornitori from '@/pages/Fornitori';
import IdFornitori from '@/pages/IdFornitori';
import Prodotti from '@/pages/Prodotti';
import Movimenti from '@/pages/Movimenti';
import Storico from '@/pages/Storico';
import Backup from '@/pages/Backup';
import OperatoreIn from '@/pages/OperatoreIn';
import OperatoreOut from '@/pages/OperatoreOut';
import OperatorePortal from '@/pages/OperatorePortal';
import DaImportare from '@/pages/DaImportare';
import Cella from '@/pages/Cella';
import CellaMovimenti from '@/pages/CellaMovimenti';
import OperatoreCellaIn from '@/pages/OperatoreCellaIn';
import OperatoreCellaOut from '@/pages/OperatoreCellaOut';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Portale Operatori - senza Layout/menu */}
          <Route path="/operatore" element={<OperatorePortal />} />
          <Route path="/operatore/cella/in" element={<OperatoreCellaIn />} />
          <Route path="/operatore/cella/out" element={<OperatoreCellaOut />} />
          
          {/* App principale con Layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/bins" element={<Bins />} />
                <Route path="/fornitori" element={<Fornitori />} />
                <Route path="/id-fornitori" element={<IdFornitori />} />
                <Route path="/prodotti" element={<Prodotti />} />
                <Route path="/movimenti" element={<Movimenti />} />
                <Route path="/storico" element={<Storico />} />
                <Route path="/backup" element={<Backup />} />
                <Route path="/operatore-in" element={<OperatoreIn />} />
                <Route path="/operatore-out" element={<OperatoreOut />} />
                <Route path="/da-importare" element={<DaImportare />} />
                <Route path="/cella" element={<Cella />} />
                <Route path="/cella/movimenti" element={<CellaMovimenti />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
